import {CALL_API} from 'redux-api-middleware';
import {AUTOSAVE_REQUEST, AUTOSAVE_SUCCESS, AUTOSAVE_FAILURE} from 'common/types';
import {commonJwtHeader} from 'common/utils';
import goStore from 'go/store';
import DynamicComponentActions from 'go/actions/dynamicComponent';

const SAVE_ENTITY_NETWORK_ERROR_MSG =
  'You have encountered an unexpected error. Please refresh your browser and try again. If you continue to receive this message, please contact the help desk at <a href="mailto:femago@fema.dhs.gov">femago@fema.dhs.gov</a> or 1-877-611-4700.';
const SAVE_ENTITY_NETWORK_ERROR_TITLE = 'Unexpected error';

/* 
There is the limitation of "redux-api-middleware" library in offline mode,
where request will not generate either success or failure event in offline mode.
We need to have the funtion to handle the situation when UI does not receive any response code 
from backend service. The two new consts, which are handleError and handleOfflineSave 
have been added to handle this situation.
*/
const handleError = async (err) => {
  console.error('FEMA GO - Failed to autosave user input. Error');
  goStore.store.dispatch(
    () =>
      new Promise(() => {
        debugBreakpoint(BREAKPOINTS.collaborationErrors);
        goStore.store.dispatch(
          DynamicComponentActions.handleSaveError({
            title: SAVE_ENTITY_NETWORK_ERROR_TITLE,
            text: SAVE_ENTITY_NETWORK_ERROR_MSG,
            message: err,
          })
        );
      })
  );
};

const handleOfflineSave = (token, endpoint, method, body, entityType) => {
  return goStore.store
    .dispatch(save(token, endpoint, method, body, entityType))
    .then((state) => {
      if (state.error && state.status !== 409) {
        return Promise.reject(state.payload.message);
      }
      return Promise.resolve(state);
    })
    .catch((err) => {
      handleError(err);
    });
};

const save = (token, endpoint, method, body, entityType) => {
  return {
    [CALL_API]: {
      endpoint: `${endpoint}`,
      method: method,
      headers: commonJwtHeader(token),
      types: [
        {
          type: AUTOSAVE_REQUEST,
          meta: {entityType: entityType},
        },
        {
          type: AUTOSAVE_SUCCESS,
          meta: {entityType: entityType},
        },
        AUTOSAVE_FAILURE,
      ],
      body: JSON.stringify(body),
    },
  };
};
export default {
  save,
  handleError,
  handleOfflineSave,
};
